import { __extends } from "tslib";
import { deserializeAws_restJson1_1CreateCampaignCommand, serializeAws_restJson1_1CreateCampaignCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var CreateCampaignCommand = /** @class */ (function (_super) {
    __extends(CreateCampaignCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateCampaignCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    CreateCampaignCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateCampaignCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1CreateCampaignCommand(input, context);
    };
    CreateCampaignCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1CreateCampaignCommand(output, context);
    };
    return CreateCampaignCommand;
}($Command));
export { CreateCampaignCommand };
//# sourceMappingURL=CreateCampaignCommand.js.map